/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { Dropdown } from 'react-bootstrap';
import objectPath from 'object-path';
import ApexCharts from 'apexcharts';
import { toAbsoluteUrl } from '../../../_helpers';
import { DropdownCustomToggler, DropdownMenu4 } from '../../dropdowns';
import { useHtmlClassService } from '../../../layout';
import axios, { baseUrl } from '../../../../redux/my-axios';

const URL = '/dashboard';
export function TilesWidget2({
  className,
  chartColor = 'primary',
  baseColor = 'success',
  title,
  target = 'MERCHANT',
  freq,
  freqFrom,
  type,
  icon = '/media/svg/icons/Layout/Layout-4-blocks.svg',
}) {
  const uiService = useHtmlClassService();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState();
  const [sum, setSum] = useState(0);
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        'js.colors.gray.gray500'
      ),
      colorsGrayGray300: objectPath.get(
        uiService.config,
        'js.colors.gray.gray300'
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.${chartColor}`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.${chartColor}`
      ),
      fontFamily: objectPath.get(uiService.config, 'js.fontFamily'),
    };
  }, [uiService, chartColor]);

  useEffect(() => {
    const element = document.getElementById('kt_tiles_widget_2_chart');

    if (!element) {
      return;
    }

    const chart = new ApexCharts(element, options);
    chart.render();
    return function cleanUp() {
      chart.destroy();
    };
  }, [layoutProps, options]);

  useEffect(() => {
    setLoading(true);
    var req = { target, type, freq, freqFrom };
    axios
      .post(URL, req, { headers: { action: 'getchart' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('Dashboard: ', response.data.data);
            //setValue(Number(response.data.data[0]));
            setOptions(
              getChartOption(
                layoutProps,
                response.data.data[0],
                response.data.data[1],
                parseFloat(response.data.data[2][1])
              )
            );
            setSum(
              parseFloat(response.data.data[2][0])
                .toString()
                .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
            );
            setLoading(false);
            break;
          default:
            console.log('Dashboard Error: ', response.data);

            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        console.log(error);

        setLoading(false);
      });
    return function cleanup() {};
  }, []);

  return (
    <>
      {/* begin::Tiles Widget 1 */}
      <div className={`card card-custom ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <div className='card-title'>
            <div className='card-label'>
              <div className='font-weight-bolder'>{title}</div>
              <div className='font-size-sm text-muted mt-2'>{sum}₮</div>
            </div>
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body d-flex flex-column px-0'>
          {/* begin::Chart */}
          {options && (
            <div
              id='kt_tiles_widget_2_chart'
              data-color={chartColor}
              style={{ height: '150px' }}
            />
          )}
          {/* end::Chart */}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Tiles Widget 1 */}
    </>
  );
}

function getChartOption(layoutProps, seriesValues, xaxisCategories, max) {
  const options = {
    series: [
      {
        name: 'Дүн',
        // data: [20, 22, 30, 28, 25, 26, 30, 28, 22, 24, 25, 35],
        data: seriesValues,
      },
    ],
    chart: {
      type: 'area',
      height: 150,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'gradient',
      opacity: 1,
      gradient: {
        type: 'vertical',
        shadeIntensity: 0.55,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 0.8,
        stops: [250000, 500000, 750000, 1000000],
        colorStops: [],
      },
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [layoutProps.colorsThemeBaseColor],
    },
    xaxis: {
      categories: xaxisCategories,
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
      labels: {
        show: false,
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: '12px',
          fontFamily: layoutProps.fontFamily,
        },
      },
      crosshairs: {
        show: true,
        position: 'front',
        stroke: {
          color: layoutProps.colorsGrayGray300,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    yaxis: {
      min: 0,
      max: max,
      labels: {
        show: false,
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: '12px',
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
        fontFamily: layoutProps.fontFamily,
      },
      y: {
        formatter: function(val) {
          return val !== 0
            ? val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
                '₮'
            : '0₮'; //'$' + val + ' thousands';
        },
      },
    },
    colors: [layoutProps.colorsThemeLightColor],
    markers: {
      colors: [layoutProps.colorsThemeLightColor],
      strokeColor: [layoutProps.colorsThemeBaseColor],
      strokeWidth: 3,
    },
    padding: {
      top: 0,
      bottom: 0,
    },
  };
  return options;
}
